import {ColourSolid, Tag} from "@twigsby/frontend-framework";
import {useNavigate} from "react-router-dom";
import {useMailbox} from "../../Providers/NewMailboxProvider";

type MailTagCollectionType  = {
    tags: Array<any>;
    small?: boolean;
    hideIcon?: boolean;
    displayLimit?: number;
    linkSlug?: string;
    removeCallback?: any;
}

type TagPropsType = {
    id: number;
    name: string;
    index: number;
    hideIcon: boolean;
    small: boolean;
    linkSlug?: string;
    removeCallback?: any;
    tagCount: number;
}

const OverflowTag  = (props: TagPropsType) => {
    return (
        <Tag
            id={-1000}
            name={`+ ${props.tagCount - props.index} Tags`}
            small={props.small}
            colour={ColourSolid.Secondary}
            hideIcon
        />
    )
}

const DisplayTag = (props: TagPropsType) => {
    const navigate = useNavigate();
    const { UpdateTagCollectionName } = useMailbox();

    return (
        <Tag
            id={props.id}
            name={props.name}
            small={props.small}
            onClickCallback={(e) => {
                e.preventDefault();
                UpdateTagCollectionName(props.name);
                navigate(`${props.linkSlug}${props.id}`)
            }}
            removeCallback={props.removeCallback ? () => props.removeCallback(props.id) : undefined}
            hideIcon={props.hideIcon}
        />
    )
}

function MailTagCollection(props: MailTagCollectionType) {
    const BuildTags = () => {
        let newTags = [];

        for (let i = 0; i < props.tags.length; i += 1) {
            if (i < (props.displayLimit || props.tags.length)) {
                newTags.push(
                    <DisplayTag
                        key={`mail-item-tag-${i}`}
                        index={i}
                        id={props.tags[i].id}
                        name={props.tags[i].labelName}
                        tagCount={props.tags.length}
                        hideIcon={false}
                        small={true}
                        linkSlug={props.linkSlug}
                        removeCallback={props.removeCallback}
                    />
                );
            } else {
                newTags.push(
                    <OverflowTag
                        key={`mail-item-tag-${i}`}
                        index={i}
                        id={props.tags[i].id}
                        name={props.tags[i].labelName}
                        tagCount={props.tags.length}
                        hideIcon={true}
                        small={true}
                    />
                );
                break;
            }
        }

        return <>{newTags}</>;
    }

    return (
        <div className="tag-group">
            <BuildTags />
        </div>
    );
}

export {MailTagCollection}
